(function ($) {
  Drupal.behaviors.giftGuide = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var noDefaultHeader = false,
        theVideo = false;

      if (!theVideo) {
        noDefaultHeader = true;
        // No video so check if there's a default image.
        if ($('.mpp-header-image').attr('src')) {
          noDefaultHeader = false;
        }
      }
      showDefaultedHeader();
      $('.gift_guide_media_header_override').hide();
      if ($('.category-detection').length) {
        // Highlight Category We Are On.
        var cat = $('.mpp__gift_guide').data('category');

        $('.product-filter__filter[data-category="' + cat + '"]').addClass('active');
      }

      // Show Default header and play video when it shows.
      function showDefaultedHeader() {
        // Only show if there's a default header.
        if (noDefaultHeader == false) {
          $('.mpp-header-media').show();
          if (theVideo) {
            // Play Video
            if (typeof theVideo.play === 'function') {
              theVideo.play();
            }
          }
        }
      }
    }
  };
})(jQuery);
